module.exports = __webpack_public_path__ + "images/ds-fp2024-bg-footer-mobile.webp";